<template>
	<div class="group-media">
		<ul class="media-links">
			<li v-for="tab in tabs" :key="tab.type">
				<RouterLink
					:to="{
						name: 'groupmedia',
						params: { ...$route.params, type: tab.type },
					}"
					:class="{ selected: selectedTab.type === tab.type }"
				>
					{{ tab.text }}
				</RouterLink>
			</li>
		</ul>

		<component
			:is="selectedTab.component"
			:chatId="chatId"
			@showProfileCard="profileData = $event"
		/>

		<ProfileCard
			v-if="profileData"
			@close="profileData = null"
			:profileData="profileData"
		/>
	</div>
</template>

<script>
import GroupMediaPhotos from '@/components/GroupSettings/GroupMediaPhotos'
import GroupMediaLinks from '@/components/GroupSettings/GroupMediaLinks'
import GroupMediaFiles from '@/components/GroupSettings/GroupMediaFiles'
import GroupMediaStreams from '@/components/GroupSettings/GroupMediaStreams'
import ProfileCard from '@/components/ProfileCard'

export default {
	components: { ProfileCard },
	props: ['type', 'chatId'],
	data() {
		return {
			profileData: null,
		}
	},
	computed: {
		tabs() {
			return [
				{
					type: 'photos',
					text: this.$t('groupsettings_mediatray_photos_videos_title'),
					component: GroupMediaPhotos,
				},
				{
					type: 'links',
					text: this.$t('groupsettings_mediatray_links_title'),
					component: GroupMediaLinks,
				},
				{
					type: 'files',
					text: this.$t('groupsettings_mediatray_files_title'),
					component: GroupMediaFiles,
				},
				{
					type: 'meetings',
					text: this.$t('groupsettings_mediatray_meetings_title'),
					component: GroupMediaStreams,
				},
			]
		},
		selectedTab() {
			return this.tabs.find((t) => t.type === this.type) || this.tabs[0]
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.media-links {
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	width: 100%;
	margin: 8px 0 10px 0;
	padding: 0 15px 20px 0;
}

.media-links li {
	display: block;
	flex: 0 1 auto;
	list-style-type: none;
}

.media-links a {
	text-decoration: none;
	font-family: Avenir-Heavy;
	font-size: 16px;
	line-height: 0.82;
	letter-spacing: -0.1px;
	color: #4f5053;
}

.media-links a.selected {
	color: var(--teal-300);
	text-decoration: underline;
}

.media-links a:hover {
	color: var(--teal-300);
	text-decoration: underline;
}

.group-media {
	overflow: hidden;
}
</style>
